
import {Component, Vue} from 'vue-property-decorator';
import RendererForm from '@/components/forms/RendererForm.vue';
import {dispatchGetForm, dispatchStoreFormsValues} from '@/store/main/actions';
import {readForm} from '@/store/main/getters';
import {IForm, IFormValues} from '@/interfaces/form';
import {commitAddNotification} from '@/store/main/mutations';
import {SearchEngineReferences} from '@/interfaces/search_engine';
import AlertDialogWrapper from '@/components/dialogs/AlertDialogWrapper.vue';
import AlertDialogFrame from '@/components/dialogs/AlertDialogFrame.vue';
import SearchEngineDialog from '@/components/dialogs/SearchEngineDialog.vue';
import {arrDifference, arrSymmetricDifference, getFormValuesHeaders} from '@/utils';

@Component({
  components: {
    SearchEngineDialog, AlertDialogWrapper, AlertDialogFrame, RendererForm,
  },
})
export default class CreateFormValues extends Vue {
  private alertDialog: any = null;
  private alertHeader: string = '';
  private alertMessage: string = '';
  private formSearchEngineDialog: any = null;

  private localFormValues: IFormValues = {} as IFormValues;
  private formID: number = 0;


  public async mounted() {
    this.formID = this.$router.currentRoute.params.id as unknown as number;
    await this.loadMountSettings();
  }

  public async beforeRouteUpdate(to, from, next) {
    this.formID = to.params.id;
    await this.loadMountSettings();
    next();
  }

  private get form() {
    return readForm(this.$store)(+this.formID);
  }


  private async loadMountSettings() {
    this.localFormValues = {} as IFormValues;
    this.formSearchEngineDialog = await this.$refs.search_engine_dialog;

    this.alertDialog = this.$refs.alert_dialog;
    // @ts-ignore
    this.$form.validationErrorAlertText = this.$t('errors.invalid_form');
    // this.$form.valueContainer = this.$t('errors.invalid_form');
    // @ts-ignore
    this.$formEvent.$off('renderer.validation_ok');
    // @ts-ignore
    this.$formEvent.$once('renderer.validation_ok', this.commitAfterFormValidation);

    await dispatchGetForm(this.$store, this.formID)
    let cForm: IForm = this.form as IForm;

    if (cForm?.id && cForm?.version) {
      this.localFormValues = {form_id: cForm.id, version: cForm.version, id: 0} as IFormValues;

      if (cForm.form_search_engine) {
        // TODO fazer método para verificar os campos do formulário e salvar apenas os campos existentes

        if (!this.formSearchEngineDialog) {
          await Promise.all([
            await new Promise((resolve, reject) => setTimeout(() => resolve(), 100)),
            this.formSearchEngineDialog = await this.$refs.search_engine_dialog,
          ]);
        }

        if (!this.formSearchEngineDialog) {
          return;
        }
        // @ts-ignore
        const response = await this.formSearchEngineDialog.open().then(async (result) => {
          if (result?.form_values) {
            const formControls = Object.values(cForm?.form_setting?.form_data?.controls!).map((e: any) =>
                e?.name ? e?.name : e.uniqueId);
            const fValues = result?.form_values;

            const reduceFormValues = formControls.reduce((object, curr, i) =>
                // (object[curr] = !fValues[curr]?.form_files_id ? fValues[curr] : null, object), {});
                (object[curr] = fValues[curr], object), {});
            const normalizedFormValues = result;
            normalizedFormValues.form_values = reduceFormValues;
            this.localFormValues = {...normalizedFormValues};
            // this.localFormValues.form_values = {...result.form_values};
          }
          return result;
        });
        if (response && cForm?.form_search_engine?.reference_type === SearchEngineReferences.OWN_FORM) {
          const formValuesID: any = this.localFormValues.id;
          await this.$router.push({name: 'main-forms-edit', params: {id: formValuesID}});
        } else {
          this.localFormValues.form_id = cForm.id;
          this.localFormValues.version = cForm.version;
          this.localFormValues.id = 0;

        }
      }
    } else {
      commitAddNotification(this.$store, {
        content: 'Ocorreu um erro ao carregar os dados do formulário. Tente novamente ou atualize a página.',
        color: 'warning',
      });
    }
  }

  private async runFormValidation() {
    if (!this.localFormValues || !this.localFormValues.form_values) {
      commitAddNotification(this.$store,
          {content: 'O formulário não está preenchido! Informe ao menos um valor para continuar...', color: 'warning'});
      // @ts-ignore
      this.$formEvent.$once('renderer.validation_ok', this.commitAfterFormValidation);
      return;
    }
    // @ts-ignore
    this.$formEvent.$emit('renderer.run_validation', true);
  }

  private async cancel() {
    await this.$router.push({name: 'main-forms-list', params: {id: `${this.formID}`}});
  }

  private async commitAfterFormValidation() {
    this.alertHeader = `Deseja registrar o formulário?`;
    this.alertMessage = `Atenção! antes de salvar, verifique cuidadosamente se todas as informações foram registradas corretamente.`;
    const resp = await this.alertDialog.open().then((result) => {
      return result;
    });
    if (!resp) {
      // @ts-ignore
      this.$formEvent.$once('renderer.validation_ok', this.commitAfterFormValidation);
      return;
    }
    // @ts-ignore
    if (await dispatchStoreFormsValues(this.$store, this.localFormValues)) {
      await this.$router.push({name: 'main-forms-list', params: {id: `${this.formID}`}});
    } else {
      // @ts-ignore
      this.$formEvent.$once('renderer.validation_ok', this.commitAfterFormValidation);
    }
  }

}
